import React, { useCallback, useEffect, useState } from "react";
import API, { LIST_RANK, LIST_REWARD_CLAIM } from "../../network/api";
import { TEXT_DEF } from "../../constant/text";
import { 
    Radio,
    Table,
    Spin,
    Pagination,
    Form,
} from "antd";

const TEXT = {
    username: "Tên đăng nhập",
    turn: "Số lượt chơi",
    rank: "Thứ hạng",
    isFake: "Là người chơi fake",
    save: "Lưu",
    action: "Hành động",
    update: "Cập nhật",
    delete: "Xóa",
    titleEdit: "Chỉnh sửa lượt chơi"
}

const RankList = () => {
    const auth = JSON.parse(localStorage.getItem("auth"));
    const [form] = Form.useForm();
    const [, forceUpdate] = useState({});

    const [dataList, setDataList] = useState([]);
    const [page, setPage] = useState(1);
    const [totalRecord, setTotalRecord] = useState(0);
    const locale = {
        emptyText: TEXT_DEF.text0035,
    };
    const [loading, setLoading] = useState(false);
    const usernameFilterLocal = localStorage.getItem("usernameFilter");
    const [dataFilter, setDataFilter] = useState();

    const [indexTab, setIndexTab] = useState(1);
    const [dataListHis, setDataListHis] = useState([]);
    
    useEffect(() => {
        forceUpdate({});
        if (usernameFilterLocal) {
            setDataFilter(`username=${usernameFilterLocal}`);
            form.setFieldValue("usernameFilter", usernameFilterLocal);
            localStorage.removeItem("usernameFilter");
        }
    }, [form, usernameFilterLocal]);

    const onChangeTab = (e) => {
        setPage(1);
        setIndexTab(e.target.value);
    };

    const dataColums = auth?.role === "super_admin" ? 
        [
            {
                title: TEXT.rank,
                align: "center",
                key: "rank",
                dataIndex: "rank",
            },
            {
                title: TEXT_DEF.text0002,
                dataIndex: "username",
                key: "username",
            },
            {
                title: TEXT.turn,
                key: "usedTurns",
                dataIndex: "usedTurns",
            },
            {
                title: TEXT.isFake,
                key: "isFake",
                render: (text, record,) => (
                    <span>{record.isFake ? "Tài khoản fake" : ""}</span>
                ),
            },
        ]:
        [
            {
                title: TEXT.rank,
                align: "center",
                key: "rank",
                dataIndex: "rank",
            },
            {
                title: TEXT_DEF.text0002,
                dataIndex: "username",
                key: "username",
            },
            {
                title: TEXT.rank,
                key: "usedTurns",
                dataIndex: "usedTurns",
            },
        ];


    const dataColumsHis = [
        {
            title: "STT",
            align: "center",
            key: "order",
            render: (text, record, index) => (
                <span>{(page - 1) * 10 + (index + 1)}</span>
            ),
        },
        {
            title: TEXT_DEF.text0002,
            dataIndex: "username",
            key: "username",
        },
        {
            title: "Số điểm đã nhận",
            key: "amount",
            dataIndex: "amount",
        },
        {
            title: TEXT.rank,
            key: "rank",
            dataIndex: "rank",
        },
    ] 

    const showTotal = (total) => `Tổng cộng ${total} dữ liệu`;

    const getListDataRank = useCallback(async () => {
        setLoading(true);
        const dataList1 = API.get(
            `${LIST_RANK}?pageSize=10&page=${page}${dataFilter ? `&${dataFilter}` : ""}`
        );

        await Promise.all([dataList1])
            .then((response) => {
                const payload = response[0].data?.data;
                const res = payload?.data ?? [];
                const dataCV = res.map((item, index) => {
                    const rank =
                        item?.rank ??
                        item?.position ??
                        (page - 1) * 10 + (index + 1);
                    return {
                        key: item?.id ?? `${item?.username || "user"}-${rank}-${page}-${index}`,
                        username: item?.username,
                        usedTurns: item?.playCount,
                        isFake: item?.isFake,
                        rank,
                    };
                });

                setDataList(dataCV);
                setTotalRecord(Number(payload?.total ?? dataCV.length) || 0);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    }, [page, dataFilter]);

    const getListDataHistoryClaim = useCallback(async () => {
        setLoading(true);
        const dataList1 = API.get(
            `${LIST_REWARD_CLAIM}?pageSize=100&page=${page}`
        );

        await Promise.all([dataList1])
            .then((response) => {
                const res = response[0].data.data.data;
                if (res) {
                    let dataCV = [];
                    res?.map((item, index) => {
                        const user = {
                            key: item?.id,
                            username: item?.username,
                            amount: item?.amount,
                            rank: item?.rank,
                        };
                        dataCV.push(user);
                        return dataCV;
                    });

                    setDataListHis(dataCV);
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    }, [page]);

    useEffect(() => {
        if (indexTab === 1) {
            getListDataRank();
        } else {
            getListDataHistoryClaim();
        }
    }, [indexTab, getListDataRank, getListDataHistoryClaim]);

    const onChangePage = (page) => {
        setPage(page);
    };

    const renderTableUser = () => {
        return (
            <Spin spinning={loading} delay={500} size="large">
                <div style={{ display: "flex", width: "100%", marginTop: 20 }}>
                    <Table
                        key="table-user-fake"
                        locale={locale}
                        columns={dataColums}
                        dataSource={dataList}
                        rowKey="key"
                        pagination={false}
                        bordered
                        style={{ width: "100%" }}
                    />
                </div>
                <div
                    style={{
                        display: "flex",
                        width: "100%",
                        marginTop: 15,
                        justifyContent: "flex-end",
                    }}
                >
                    <Pagination
                        current={page}
                        total={totalRecord}
                        onChange={onChangePage}
                        defaultPageSize={10}
                        showSizeChanger={false}
                        showTotal={showTotal}
                    />
                </div>
            </Spin>
        )
    }

    const renderTableHis = () => {
        return (
            <Spin spinning={loading} delay={500} size="large">
                <div style={{ display: "flex", width: "100%", marginTop: 20 }}>
                    <Table
                        key="table-history-claim"
                        locale={locale}
                        columns={dataColumsHis}
                        dataSource={dataListHis}
                        pagination={false}
                        bordered
                        style={{ width: "100%" }}
                    />
                </div>
            </Spin>
        )
    }

    return (
        <div className="col-12">
            {/* <div className="col-12">
                <Form
                    form={form}
                    layout="inline"
                    autoComplete="off"
                    onFinish={() => onSearch()}
                >
                    <div
                        className="col-12"
                        style={{ marginBottom: 15, display: "flex" }}
                    >
                        <div className="col-5">
                            <Form.Item name="usernameFilter" label={TEXT_DEF.text0002}>
                                <Input style={{ width: "100%" }} />
                            </Form.Item>
                        </div>
                    </div>

                    <div className="payment-search">
                        <Button htmlType="submit" type="primary">
                            {TEXT_DEF.text0031}
                        </Button>
                    </div>
                </Form>
            </div> */}
            {auth?.role === "super_admin" ? (
                <div
                    className="col-12"
                    style={{
                        borderBottom: "1px solid #CCC",
                        paddingBottom: "2rem",
                        marginBottom: "2rem",
                    }}
                >
                    <Radio.Group value={indexTab} onChange={onChangeTab}>
                        <Radio.Button value={1}>Bảng xếp hạng</Radio.Button>
                        <Radio.Button value={2}>Lịch sử nhận điểm</Radio.Button>
                    </Radio.Group>
                </div>
            ) : null}
            {indexTab === 1 ? renderTableUser() : renderTableHis()}
        </div>
    );
};

export default RankList;
